var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgInfoFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18px",
  height: "18px",
  viewBox: "0 0 18 18",
  fill: "#BECCD8",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("ellipse", {
  stroke: "null",
  ry: 7.558592796325684,
  rx: 7.696706771850586,
  cy: 8.960762977600098,
  cx: 9.050224304199219,
  strokeWidth: "null",
  className: "selected",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0Zm0 1.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM9 7a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1Zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"
}))));

export default SvgInfoFilled;